import { Star, ShieldCheck, Clock, ThumbsUp, ExternalLink } from "lucide-react";

const GOOGLE_URL = "https://g.page/r/CdFVvohyjpRZEAI/review";

export default function Reviews() {
  return (
    <section data-testid="reviews-section" id="reviews" className="py-24 sm:py-32 px-6 lg:px-8 bg-[#171717] border-y border-white/10">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#F59E0B] mb-4">Why Homeowners Call Us</p>
        <h2 className="font-display uppercase tracking-tight text-4xl sm:text-5xl mb-14">Built On Trust &amp; Reviews</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {[
            { icon: ShieldCheck, title: "Reliable & Insured", text: "We show up when we say we will and treat your property like our own." },
            { icon: Clock, title: "7 Days A Week", text: "Open 9am to 7pm every single day — including weekends and snow days." },
            { icon: ThumbsUp, title: "Fair, Honest Quotes", text: "No hidden fees. Call for a quote and get a straight answer, fast." },
          ].map((t) => (
            <div key={t.title} data-testid={`trust-card-${t.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="bg-[#0A0A0A] border border-white/10 p-8 flex flex-col gap-4 transition-transform duration-300 hover:-translate-y-1">
              <t.icon className="w-8 h-8 text-[#F59E0B]" strokeWidth={2} />
              <h3 className="font-display uppercase text-2xl tracking-tight">{t.title}</h3>
              <p className="text-neutral-400 text-sm leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>
        <div>
          <a
            data-testid="google-reviews-link"
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-[#0A0A0A] border border-white/10 p-8 flex items-center justify-between gap-4 hover:border-[#F59E0B] transition-colors duration-200"
          >
            <div>
              <div className="flex gap-1 mb-3" aria-label="5 star rating">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-[#F59E0B] fill-[#F59E0B]" />
                ))}
              </div>
              <h3 className="font-display uppercase text-2xl tracking-tight mb-1">Google Reviews</h3>
              <p className="text-neutral-400 text-sm">Read our reviews — or leave one after your job is done. It takes a minute and means the world to us.</p>
            </div>
            <ExternalLink className="w-6 h-6 text-neutral-500 group-hover:text-[#F59E0B] transition-colors duration-200 shrink-0" />
          </a>
        </div>
      </div>
    </section>
  );
}
